export const MODAL_CLOSE = 'modal-close';
